module.exports = __webpack_public_path__ + "img/9788949123431.e8836ff0.jpg";